import React, { useEffect, useState } from 'react';
export function NotificationBar() {
  // Start with 59 minutes and 51 seconds
  const [timeLeft, setTimeLeft] = useState(59 * 60 + 51);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (seconds: number) => {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor(seconds % 3600 / 60);
    const s = seconds % 60;
    return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
  };
  return <div className="sticky top-0 z-50 w-full bg-brand-red text-white py-3 px-4 text-center shadow-md" data-id="element-80">
      <p className="font-opensans font-semibold text-sm md:text-base flex flex-col md:flex-row items-center justify-center gap-1 md:gap-2" data-id="element-81">
        <span className="uppercase tracking-wide" data-id="element-82">
          Special Launch Price: Get Instant Access Today for Just $9.99
        </span>
        <span className="font-montserrat font-bold bg-black/20 px-2 py-0.5 rounded tracking-widest" data-id="element-83">
          [{formatTime(timeLeft)}]
        </span>
        <span data-id="element-84">Remaining.</span>
      </p>
    </div>;
}